import urls from "../../global/constants/UrlConstants";
import { getNoAuthCallParams, makeCall } from "../../utils/service";

export const getLanguages = async () => {
  try {
    const callParams = await getNoAuthCallParams("GET");
    const response = await makeCall(urls.GET_LANGUAGES, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getModelName = async () => {
  try {
    const callParams = await getNoAuthCallParams("GET");
    const response = await makeCall(urls.GET_MODEL_NAME, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const generateContent = async (obj: any) => {
  try {
    const callParams = await getNoAuthCallParams("POST", obj);
    const response = await makeCall(urls.GENERATE, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const translateContent = async (obj: any) => {
  try {
    const callParams = await getNoAuthCallParams("POST", obj);
    const response = await makeCall(urls.TRANSLATE, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchData = async () => {
  try {
    const callParams = await getNoAuthCallParams("GET");
    const response = await makeCall(urls.FETCH_DATA, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getQuestionAnswers = async (obj: any) => {
  try {
    const callParams = await getNoAuthCallParams("POST", obj);
    const response = await makeCall(urls.QUESTION_ANSWERS, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
